/*----------------------------------------------------

	onload.js

----------------------------------------------------*/

// Polyfill forEach for ES5
if(window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// is visible
function isVisible(obj){
  return obj.offsetWidth > 0 && obj.offsetHeight > 0;
}

// is in viewport
var isInViewport = function (elem) {
  var bounding = elem.getBoundingClientRect();
  return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

// cookies
function setCookie(name,value,days) {
  if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString()
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function deleteCookie(name) {
  setCookie(name,"",-1);
}

// debounce
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      timeout = null;
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// scrolling
function distanceToTop(el){
  return Math.floor(el.getBoundingClientRect().top - 40);
}
function scrollTo(targetAnchor){
  if (!targetAnchor) return;
  var originalTop = distanceToTop(targetAnchor);
  var isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;

  if(isSmoothScrollSupported){
    window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' });
  }else{
    window.scrollBy(0,originalTop);
  }

  var checkIfDone = setInterval(function() {
    var atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
    if (distanceToTop(targetAnchor) === 0 || atBottom) {
      targetAnchor.tabIndex = '-1';
      //targetAnchor.focus();
      clearInterval(checkIfDone);
    }
  }, 100);

}


/* dynamic loading
----------------------------------------------------------------------------------------------------*/

function loadScript(url){
  (function(document, tag) {
      var scriptTag = document.createElement(tag), // create a script tag
          firstScriptTag = document.getElementsByTagName(tag)[0]; // find the first script tag in the document
      scriptTag.src = url; // set the source of the script to your script
      firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
  }(document, 'script'));
}

function loadCSS(url){
  var head = document.getElementsByTagName('head')[0];
  var link  = document.createElement('link');
  link.rel  = 'stylesheet';
  link.type = 'text/css';
  link.href = url;
  head.appendChild(link);
}

// googlemaps
/*if(document.querySelectorAll('.map-canvas').length > 0){
  loadScript('/inc/js/googlemaps.js');
}*/


// lightbox - baguetteBox
/*if(document.querySelectorAll('.gallery').length > 0 || document.querySelectorAll('.lightbox').length > 0){
  loadScript('/inc/js/baguetteBox.js');
  loadCSS('/inc/css/plugins/baguetteBox.css');
}*/



/* external links in new tab
----------------------------------------------------------------------------------------------------*/

var links = document.links;

for(var i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname != window.location.hostname || links[i].getAttribute('href').match('.pdf$')) {
    links[i].target = '_blank';
  }
}




/* JS / bubble links
----------------------------------------------------------------------------------------------------*/

(function(){

  'use strict';

  // Feature Test
  if('querySelector' in document && 'addEventListener' in window && Array.prototype.forEach){

    var bubbleLink = document.querySelectorAll('.js-link');
    [].forEach.call(bubbleLink, function(bubble){

      bubble.addEventListener('click', function(e){

        if(e.target.tagName.toLowerCase() !== 'a'){

          e.preventDefault();

          var destination_link = bubble.querySelector('a:first-of-type');
          var destination = bubble.querySelector('a:first-of-type').getAttribute('href');
          if(destination){
            if(e.ctrlKey || bubble.getAttribute('target') == '_blank' || bubble.querySelector('a:first-of-type').classList.contains('externalLink')){
              window.open(destination,'_blank')
            }else{
              simulateClick(destination_link);
              //window.location.href = destination;
            }
          }

        }

      }, false);

    });

  }

})();

var simulateClick = function (elem) {
  // Create our event (with options)
  var evt = new MouseEvent('click', {
    bubbles: false,
    cancelable: true,
    view: window
  });
  // If cancelled, don't dispatch our event
  var cancelled = !elem.dispatchEvent(evt);
};




/* generic showhide
----------------------------------------------------------------------------------------------------*/

var showhide_links = document.querySelectorAll('[data-showhide],[data-showhidemobile]');

// For each
[].forEach.call(showhide_links, function(link){

  link.addEventListener('click', function(ev){

    // Prevent the default link behavior
    ev.preventDefault();
    ev.stopPropagation();

    var target = (link.dataset.showhide) ? document.querySelector(link.dataset.showhide) : document.querySelector(link.getAttribute('href'));

    // if nav check if is in viewport, for others check if visible
    if((target.id == 'nav' && isInViewport(target)) || (target.id != 'nav' && isVisible(target))){
      target.classList.remove('show');
    }else{
      closeShowHide(ev);
      target.classList.add('show');

      var child_links = target.querySelectorAll('a');
      [].forEach.call(child_links, function(cl){
        cl.addEventListener('click', function(ev){
          closeShowHide(target);
        });
      });

    }

  });

});


function closeShowHide(ev){
  var docclose = document.querySelectorAll('[data-docclose],[data-hidesiblings]');
  [].forEach.call(docclose, function(link){
    if(ev.target && isVisible(link) && ev.target !== link && !link.contains(ev.target)){
      link.classList.remove('show');
    }
  });
}

document.addEventListener('click', function(ev){
  closeShowHide(ev);
});




/* generic form submit
----------------------------------------------------------------------------------------------------*/

function wrapInner(parent, wrapper, attribute, attributevalue) {
  if (typeof wrapper === "string") {
      wrapper = document.createElement(wrapper);
  }
  var div = parent.appendChild(wrapper).setAttribute(attribute, attributevalue);

  while (parent.firstChild !== wrapper){
    wrapper.appendChild(parent.firstChild);
  }
}

//document.querySelector('body').addEventListener('submit',function(ev){
document.querySelector('body').addEventListener('click', function(ev) {

  console.log('submit');

  if(ev.target && ev.target.type === 'submit' && ev.target.closest('form').classList.contains('js-formsubmit')) {

  //if(ev.target && ev.target.classList.contains('js-formsubmit')){
    ev.preventDefault();

    var delay = 750;
    var this_form = ev.target.closest('form');

    var action = this_form.getAttribute('action').split("#")[0];
    var method = this_form.getAttribute('method');
    var transition = this_form.getAttribute('data-formtransistion');

    var replace_id = (this_form.hasAttribute('data-formsubmit')) ? this_form.getAttribute('data-formsubmit') : '#' + this_form.getAttribute('id'); // allows to specify parent or different element
    var replace_destination = document.querySelector(replace_id);

    let data = new FormData(this_form);
    let queryString = new URLSearchParams(data).toString();


    // loading button
    //var btn = this_form.querySelectorAll('[class^="btn"]');
    var btn = ev.target;
    if(btn.length > 0){
      btn = btn[0];
      /*btn.removeClass (function (index, css) {
        return (css.match (/(^|\s)btn--arrow\S+/g) || []).join(' '); // remove btn--arrow--????
      });*/
      var btn_class = btn.getAttribute('class');
      btn_class = btn_class.replace('btn--stroke','btn--fill',btn_class); // change stroke to fill
      btn.setAttribute('class',btn_class);
      btn.setAttribute('style','flex-direction:column');
      wrapInner(btn,'span','style','height:0px;overflow:hidden;');

      var img = document.createElement('img');
      img.src = "/inc/img/loading.svg";
      img.className = 'btn__loading';
      img.alt = 'Sending';
      btn.appendChild(img);

    }else if(this_form.classList.contains('form--icon-submit')){
      var btn = this_form.querySelectorAll('button');
      if(btn.length > 0){
        btn[0].innerHTML ='<img src="/inc/img/loading--dark.svg" alt="Sending">';
      }
    }

    
    // submit and return the form
    // post needs testing
    init = {};
    if(method == 'get'){
      action += '?ajax=true&' + queryString;
    }else{
      init = {method: method, body: data};
      data.append('ajax',true); 
    }

    // add pressed button action
    data.append('action',ev.target.value); 

    fetch(action,init)
    .then( response => response.text())
    .then( result => {

      setTimeout(function(){

        // get response
        let parser = new DOMParser();
        doc = parser.parseFromString(result, 'text/html');


        // get new destination
        var to_replace = doc.querySelector(replace_id).innerHTML;
        var does_alert_exist = replace_destination.querySelectorAll('.alert').length;


        // replace page section
        replace_destination.innerHTML = to_replace;
        if(transition == 'flash'){
          replace_destination.style.opacity = 0;
          replace_destination.classList.add('fade-in');
          setTimeout(function(){
            replace_destination.removeAttribute('style');
            replace_destination.classList.remove('fade-in');
          },delay); 
        }

        // rerun any code that runs on onload
        //initTabs();
        initMultiStep();
        initAllCheckbox();
        

        // alert rendering
        var alert = replace_destination.querySelector('.alert');
        if(alert != null){
        if(does_alert_exist < 1){
          alert.style.maxHeight = 0;
          alert.classList.add('slide-down');
          setTimeout(function(){
            alert.removeAttribute('style');
            alert.classList.remove('slide-down');
          },delay); 
        }else{
          alert.style.opacity = 0;
          alert.classList.add('fade-in');
          setTimeout(function(){
            alert.removeAttribute('style');
            alert.classList.remove('fade-in');
          },delay); 
        }


        // scroll to alert if offscreen
        console.log(isInViewport(alert));
        if(!isInViewport(alert)){
          scrollTo(alert);
        }

        // Create and dispatch the custom event
        const ajaxSuccessEvent = new Event('ajaxSuccess');
        document.dispatchEvent(ajaxSuccessEvent);
        console.log('ajaxSuccess');

      } // end if alert != null
        

      },delay);

    });

  }

});




/* toggle submit
----------------------------------------------------------------------------------------------------*/

document.querySelector('body').addEventListener('change',function(ev){
  if(ev.target && ev.target.classList.contains('checkbox-toggle')){
    var domEvent = new Event('submit', {'bubbles' : true, 'cancelable' : true});
    ev.target.closest('form').dispatchEvent(domEvent);
  }
});




/* multi-step form
----------------------------------------------------------------------------------------------------*/

function initMultiStep(){

  // Get the form & fieldsets
  const form = document.querySelector('.form--multi-step');
  if(form !== null){

    const fieldsets = form.querySelectorAll('fieldset');

    // create progress bar & assign ids
    initProgressBar(form,fieldsets);
    

    // hide fieldsets
    for (var i = 0; i < fieldsets.length; i++) {
      fieldsets[i].classList.add("hidden");
    }
    let currentFieldset = localStorage.getItem("currentFieldset");
    if(currentFieldset){
      form.querySelector('#' + currentFieldset).classList.remove("hidden");
      document.querySelector('.progress [href="#' + currentFieldset + '"]').closest('li').classList.add("current");
    }else{
      fieldsets[0].classList.remove("hidden");
      document.querySelector('.progress li:first-child').classList.add("current");
    }


    // create buttons
    initFieldsetButtons(fieldsets);

  }

}
initMultiStep();


function initProgressBar(form,fieldsets){

  // Create the unordered list
  const stepLinksList = document.createElement('ul');
  stepLinksList.classList.add('progress');
  
  fieldsets.forEach((fieldset, index) => {
    // Add a unique ID to each fieldset
    const fieldsetId = `step${index + 1}`;
    fieldset.id = fieldsetId;

    // get text for item
    var text_label = (fieldset.querySelector('legend').dataset.progress) ? fieldset.querySelector('legend').dataset.progress : fieldset.querySelector('legend').textContent;
    
    
    // Create a list item and link for each fieldset
    const listItem = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${fieldsetId}`;
    link.innerHTML = "<span>" + text_label + "</span>";
    
    // Append the link to the list item and list item to the unordered list
    listItem.appendChild(link);
    stepLinksList.appendChild(listItem);
  });
  
  // Insert the unordered list before the form
  form.insertAdjacentElement('beforebegin', stepLinksList);

  // assign events to progress links
  var progressLinks = document.querySelectorAll(".progress a");
  progressLinks.forEach(function(link) {
    link.addEventListener("click", function(ev) {
      ev.preventDefault();
      showFieldset(document.querySelector(getAnchor(link.href)));
    });
  });

}


function initFieldsetButtons(fieldsets){

  for (var i = 0; i < fieldsets.length; i++) {

    var fieldset = fieldsets[i];
    var backButton = nextButton = undefined;

    // Check if fieldset does not have a child with class 'form--actions'
    if (!fieldset.querySelector('.form-actions')) {
      const formActions = document.createElement('div');
      formActions.classList.add('form-actions');
      fieldset.appendChild(formActions);
    }
    var formActions = fieldset.querySelector(".form-actions");

    // Add buttons to each fieldset
    if (i !== 0) {
      var backButton = document.createElement("a");
      backButton.innerHTML = '<svg viewBox="0 0 100 100" class="icon icon-chevron-down"><use xlink:href="#chevron-down"></use></svg> Back';
      backButton.href = "#step" + (i);
      backButton.classList.add("btn--stroke--lightblue","btn--arrowleft");
    }

    if (i !== fieldsets.length - 1) {
      var nextButton = document.createElement("a");
      nextButton.innerHTML = 'Continue <svg viewBox="0 0 100 100" class="icon icon-chevron-down"><use xlink:href="#chevron-down"></use></svg>';
      nextButton.href = "#step" + (i + 2);
      nextButton.classList.add("btn--fill--lightblue","btn--arrowright");
    }

    // append buttons and add event listeners
    if(backButton !== undefined){
      formActions.insertBefore(backButton,formActions.firstChild);

      backButton.addEventListener("click", function(ev) {
        ev.preventDefault();
        showFieldset(this.closest('fieldset').previousElementSibling);
      });
    }
    if(nextButton !== undefined){
      formActions.appendChild(nextButton);

      nextButton.addEventListener("click", function(ev) {
        ev.preventDefault();
        showFieldset(this.closest('fieldset').nextElementSibling);
      });
    }

  }
}


// Function to show the relevant fieldset and hide all others
function showFieldset(fieldset) {

  // Store the ID of the fieldset in localStorage
  localStorage.setItem("currentFieldset", fieldset.id);

  // show fieldset
  var fieldsets = document.getElementsByTagName("fieldset");
  for (var i = 0; i < fieldsets.length; i++) {
    fieldsets[i].classList.add("hidden");
  }
  fieldset.classList.remove("hidden");
  fieldset.scrollIntoView({ behavior: "smooth" });

  // Update progress indicators
  var progressLinks = document.querySelectorAll(".progress li");
  for (var i = 0; i < progressLinks.length; i++) {
    var link = progressLinks[i];
    if (getAnchor(link.querySelector('a').href) === "#" + fieldset.id) {
      link.classList.add("current");
    } else {
      link.classList.remove("current");
    }
  }

  const formGotoDiv = document.querySelector('.form--goto');
  if(formGotoDiv){
    hideGoTo();
  }

}


function getAnchor(currentUrl){
  urlParts = currentUrl.split('#');
  return (urlParts.length > 1) ? '#' + urlParts[1] : null;
}



// link to input that should alter fieldset view
function handleMultiStepLinkClick(event) {
  event.preventDefault();
  const hrefValue = event.target.getAttribute('href');
  if(hrefValue && hrefValue.startsWith('#')) {
    const targetFieldset = document.querySelector(hrefValue).closest('fieldset');
    if (targetFieldset) {
      showFieldset(targetFieldset);
    }
  }
}

document.querySelectorAll('a[data-multisteplink]').forEach(link => {
  link.addEventListener('click', handleMultiStepLinkClick);
});


/* select all checkbox
----------------------------------------------------------------------------------------------------*/

function initAllCheckbox(){

  var addAllCheckbox = document.querySelectorAll('[data-checkboxall]');

  [].forEach.call(addAllCheckbox, function(allCheckboxContainer){

    if(allCheckboxContainer){

      var locationCheckboxes = allCheckboxContainer.querySelectorAll('input[type="checkbox"]');
      var groupName = locationCheckboxes[0].getAttribute('name').replace('[]','_all');
      var checkboxAllValue = allCheckboxContainer.getAttribute('data-checkboxall');
      var allCheckbox = '';

      function checkAllLocations() {
        var allChecked = true;
        for (var i = 0; i < locationCheckboxes.length; i++) {
          if (!locationCheckboxes[i].checked) {
            allChecked = false;
            break;
          }
        }
        allCheckbox.checked = allChecked;
      }

      function updateLocations() {
        var allChecked = allCheckbox.checked;
        for (var i = 0; i < locationCheckboxes.length; i++) {
          locationCheckboxes[i].checked = allChecked;
        }
      }

      function createAllCheckbox() {
        var label = document.createElement('label');
        label.setAttribute('for', groupName);
        label.className = 'checkbox';
        label.textContent = checkboxAllValue;

        var input = document.createElement('input');
        input.className = 'checkbox';
        input.setAttribute('type', 'checkbox');
        input.setAttribute('name', groupName);
        input.setAttribute('id', groupName);

        allCheckboxContainer.insertBefore(label, allCheckboxContainer.firstChild);
        allCheckboxContainer.insertBefore(input, allCheckboxContainer.firstChild);

        allCheckbox = document.querySelector('#' + groupName);

        // listen to all checkbox change
        allCheckbox.addEventListener('change', updateLocations);

      }

      // create all checkbox
      createAllCheckbox();

      // list to changes through all other checkboxes
      for (var i = 0; i < locationCheckboxes.length; i++) {
        locationCheckboxes[i].addEventListener('change', function() {
          if (!this.checked && allCheckbox.checked) {
            allCheckbox.checked = false;
          }
          checkAllLocations();
        });
      }

      // onload
      checkAllLocations();

    }

  });

}
initAllCheckbox();




/* accordion (open status)
----------------------------------------------------------------------------------------------------*/

const accordionToggle = document.querySelectorAll('.accordion h6 a');

if (accordionToggle.length) {
  const elements = document.querySelectorAll('.accordion__item');

  function handleClassNameChange(element) {
    const thisToggle = element.previousElementSibling.querySelector('a');
    const isOpen = thisToggle.classList.contains('open');
    accordionToggle.forEach(a => a.classList.remove('open'));
    if (!isOpen) {
      thisToggle.classList.add('open');
    }
  }

  elements.forEach(function(element) {
    const observer = new MutationObserver(function(mutationsList) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          handleClassNameChange(element);
        }
      }
    });

    observer.observe(element, { attributes: true });
  });
}




/* slider
---------------------------------------------------------------------------------------------------- */

function wrap(el, wrapper) {
  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);
}

if(window.matchMedia("(max-width:919px)").matches){
  const slidersMobile = document.querySelectorAll('.slider-mobile');
  for (const sliderMobile of slidersMobile) {
    sliderMobile.classList.remove('slider-mobile');
    sliderMobile.classList.add('slider');
  }
}

const sliderContainers = document.querySelectorAll('.slider');
const arrowIcon = '<svg viewBox="0 0 100 100" class="icon icon-chevron-down"><use xlink:href="/inc/img/svg-icons.svg#chevron-down"></use></svg>';

for (const sliderContainer of sliderContainers) {

  if (!sliderContainer) {
    continue;
  }

  const breakout = sliderContainer.hasAttribute('data-breakout');
  const breakoutRight = sliderContainer.hasAttribute('data-breakoutright');
  const wrapClass = sliderContainer.hasAttribute('data-wrapclass') ? sliderContainer.getAttribute('data-wrapclass') : 'slider-wrap';

  const wrapper = document.createElement('div');
  wrapper.classList.add(...wrapClass.split(' '));
  if (breakout) {
    wrapper.classList.add('breakout');
  } else if (breakoutRight) {
    wrapper.classList.add('breakout', 'breakout--right');
  }
  wrap(sliderContainer, wrapper);

  const prev = document.createElement('a');
  prev.classList.add('slider__nav__item', 'slider__nav__item--prev');
  prev.setAttribute('href', '#');
  prev.innerHTML = arrowIcon + '<span class="screen-reader-text">Previous</span>';
  const next = document.createElement('a');
  next.classList.add('slider__nav__item', 'slider__nav__item--next');
  next.setAttribute('href', '#');
  next.innerHTML = '<span class="screen-reader-text">Next</span>' + arrowIcon;
  sliderContainer.after(prev, next);

}

const navLinks = document.querySelectorAll('.slider__nav__item');
for (const navLink of navLinks) {

  navLink.addEventListener('click', (event) => {

    event.preventDefault();

    const direction = navLink.classList.contains('slider__nav__item--prev') ? 'prev' : 'next';
    const clickedSliderContainer = navLink.parentNode.querySelector('.slider');

    if (direction === 'next') {
      const firstChild = getFirstVisibleItem(clickedSliderContainer);
      if(firstChild){
        const scrollAmount = parseInt(firstChild.offsetWidth);
        clickedSliderContainer.scrollLeft += scrollAmount;
      }
    } else if (direction === 'prev') {
      const firstChild = getFirstVisibleItem(clickedSliderContainer,-1);
      if(firstChild){
        const scrollAmount = parseInt(firstChild.offsetWidth);
        clickedSliderContainer.scrollLeft -= scrollAmount;
      }
    }

  });

}

function getFirstVisibleItem(container, factor = 0) {

  const bodyPadding = parseFloat(getComputedStyle(document.body).paddingLeft);
  const containerRect = container.getBoundingClientRect();
  const containerLeft = containerRect.left;
  const containerWidth = containerRect.width;

  const items = container.children;

  let firstVisibleItem = null;

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const itemRect = item.getBoundingClientRect();
    const itemLeft = itemRect.left - containerLeft;
    const itemRight = itemRect.right - containerLeft;
    
    if (Math.floor(itemRight) >= (bodyPadding + 1)) {
      firstVisibleItem = i + factor;
      break;
    }
  }

  return items[firstVisibleItem];
}




/* filter search
---------------------------------------------------------------------------------------------------- */

function filterLabels() {

  // Select necessary elements
  const searchInput = document.querySelector('.filters__search input');

  if(searchInput){

    const labels = document.querySelectorAll('.filters__contents label');
    const fieldsets = document.querySelectorAll('.filters__contents fieldset');
    const accordion = document.querySelector('.accordion');
    const alertError = document.createElement('div');
    alertError.className = 'alert alert--block alert--information';
    alertError.innerHTML = '<h6>No results</h6><p>Your search has returned no filter options, please try a different search.</p>';

    // Select h6 and accordion__item elements
    const h6Elements = document.querySelectorAll('.filters__contents h6');
    const accordionItems = document.querySelectorAll('.accordion__item');

    // Event listener for input changes in the search input
    searchInput.addEventListener('input', function () {
      const searchText = searchInput.value.trim();

      if (searchText.length >= 3) {
        let matchFound = false;

        // Iterate through each label and compare its text content to the search text
        labels.forEach(function (label) {
          const labelText = label.textContent.toLowerCase();

          if (labelText.includes(searchText.toLowerCase())) {
            label.classList.remove('hidden');
            matchFound = true;
          } else {
            label.classList.add('hidden');
          }
        });

        // Iterate through each fieldset to check if any labels are visible
        fieldsets.forEach(function (fieldset) {
          const labelsInFieldset = fieldset.querySelectorAll('label');
          let anyLabelVisible = false;

          labelsInFieldset.forEach(function (label) {
            if (!label.classList.contains('hidden')) {
              anyLabelVisible = true;
            }
          });

          // Show or hide the fieldset based on label visibility
          if (!anyLabelVisible) {
            fieldset.classList.add('hidden');
          } else {
            fieldset.classList.remove('hidden');
          }
        });

        // Iterate through h6 elements and hide corresponding accordion__item if no label matches found
        h6Elements.forEach(function (h6) {
          const accordionItem = h6.nextElementSibling;

          if (accordionItem && !accordionItem.querySelector('label:not(.hidden)')) {
            h6.classList.add('hidden');
            accordionItem.classList.add('hidden');
          } else {
            h6.classList.remove('hidden');
            accordionItem.classList.remove('hidden');
          }
        });

        if (matchFound) {
          // Remove the "accordion" class if matches are found
          accordion.classList.remove('accordion');
        } else {
          // Add the "accordion" class, hide all fieldsets, and show the error message if no matches are found
          accordion.classList.add('accordion');
          fieldsets.forEach(function (fieldset) {
            fieldset.classList.add('hidden');
          });
          if (!document.querySelector('.alert.alert--error')) {
            document.querySelector('.filters__contents').prepend(alertError);
          }
        }
      } else {
        // Show all labels, fieldsets, h6, and accordion__item elements, add the "accordion" class, and remove error message if present
        labels.forEach(function (label) {
          label.classList.remove('hidden');
        });
        fieldsets.forEach(function (fieldset) {
          fieldset.classList.remove('hidden');
        });
        h6Elements.forEach(function (h6) {
          h6.classList.remove('hidden');
        });
        accordionItems.forEach(function (accordionItem) {
          accordionItem.classList.remove('hidden');
        });
        accordion.classList.add('accordion');
        const existingAlert = document.querySelector('.alert.alert--error');
        if (existingAlert) {
          existingAlert.remove();
        }
      }
    });

  }
}

// Call the filterLabels function to set up the filtering behavior
filterLabels();

if(document.querySelector('.filters')){

  // close filters
  function handleFiltersClick(event) {
    const filters = document.querySelector('.filters');
    const isInnerChildClicked = event.target.closest('.filters__inner') !== null;

    if (!isInnerChildClicked) {
      filters.classList.remove('show');
    }
  }

  function handleFiltersCloseClick(event) {
    const filters = document.querySelector('.filters');
    filters.classList.remove('show');
  }

  const filtersElement = document.querySelector('.filters');
  const filtersCloseElement = document.querySelector('.filters__close');

  filtersElement.addEventListener('click', handleFiltersClick);
  filtersCloseElement.addEventListener('click', handleFiltersCloseClick);

}